import VueLib from 'vue'
import * as Sentry from '@sentry/browser'

import { Dedupe, ExtraErrorData, ReportingObserver, RewriteFrames, Vue } from '@sentry/integrations'

export default function (ctx, inject) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {"dsn":"https:\u002F\u002F5733b9553c714a33a12cf1095435bfe7@o417190.ingest.sentry.io\u002F5372504","environment":"production","release":"release-production-202611051245","beforeBreadcrumb":(breadcrumb) => {
        const category = breadcrumb && breadcrumb.category
        if (
          (category === 'xhr' ||
            category === 'fetch' ||
            category === 'navigation') &&
          breadcrumb.data
        ) {
          ;['url', 'from', 'to'].forEach((key) => {
            if (typeof breadcrumb.data[key] === 'string') {
              breadcrumb.data[key] = breadcrumb.data[key]
                .split('#')[0]
                .split('?')[0]
            }
          })
        }
        return breadcrumb
      },"beforeSend":(event, hint) => {
        if (event && event.request && typeof event.request.url === 'string') {
          event.request.url = event.request.url.split('#')[0].split('?')[0]
        }
        // axios の失敗は、どの API で起きてもスタックトレースが axios の内部だけになるので、Sentry は別々の API の
        // 失敗を 1 つの課題にまとめてしまい、課題を見てもどの API か分からない。メソッドとパスで分け、タイトルにも出す
        const error = hint && hint.originalException
        const request = error && error.isAxiosError && error.config
        const exception =
          event &&
          event.exception &&
          event.exception.values &&
          event.exception.values[0]
        if (request && exception) {
          const method = String(request.method || 'get').toUpperCase()
          // 数字の ID ごとに課題が分かれないよう、数字だけの区切りは :id にまとめる
          const path = String(request.url || '')
            .split('#')[0]
            .split('?')[0]
            .replace(/^https?:\/\/[^/]+/, '')
            .replace(/\/\d+(?=\/|$)/g, '/:id')
          const status = error.response ? error.response.status : 'no-response'
          event.fingerprint = ['axios', method, path, String(status)]
          exception.value = `${exception.value} (${method} ${path})`
        }
        return event
      }}
  config.integrations = [
    new Dedupe({}),
    new ExtraErrorData({}),
    new ReportingObserver({}),
    new RewriteFrames({}),
    new Vue({ Vue: VueLib, ...{"attachProps":true,"logErrors":false}})
  ]

  /* eslint-enable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  Sentry.init(config)

  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
